export enum ErrorMessage {
    FETCH_DEALS_FAILURE_MESSAGE = 'Fetch Deals Failure',
    UPDATE_DEAL_FAILURE_MESSAGE = 'Update Deal Failure',
    DEALER_DETAILS_FAILURE_MESSAGE = 'Dealer Details Failure',
    FETCH_DEALERSHIPS_FAILURE_MESSAGE = 'Fetch Dealerships Failure',
    CHECKIN_FAILURE_MESSAGE = 'Check-in Failure',
    BOOTSTRAP_CONFIG_FAILURE_MESSAGE = 'Bootstrap Config Failure',
    BOOTSTRAP_CONFIG_DEAL_FAILURE_MESSAGE = 'Bootstrap Config Deal Failure',
    GENERIC_ERROR_MESSAGE = 'An error occurred',
    DEFAULT_THEME_LOADING_FAILURE_MESSAGE = 'Error while loading default theme',
    TRADE_IN_UPDATE_FAILURE_MESSAGE = 'Trade-In Update Failure',
    TRADE_IN_REMOVE_FAILURE_MESSAGE = 'Trade-In Remove Failure',
    NO_DEALERSHIPS_AVAILABLE = 'No Dealerships Available'
}

export enum ErrorType {
    ERROR = 'error',
    INFO = 'info'
}
